// Mock data for HSS Feed - First Season Artist Information clone.
// Content mirrors the real First Season Artist Information form.

export const heroStats = [
  { value: "10", label: "Sections" },
  { value: "15\u201320", label: "Minutes" },
  { value: "Private", label: "Uploads" },
];

export const navLinks = [
  { label: "HSS Theater", href: "#theater" },
  { label: "The Props", href: "#props" },
  { label: "Merch", href: "#merch" },
  { label: "Newsletter", href: "#newsletter" },
];

export const footerColumns = [
  { title: "Watch", links: ["TikTok", "Instagram", "YouTube", "Twitch"] },
  { title: "Get Involved", links: ["Submit Your Music", "The Props", "Newsletter"] },
  { title: "Shop & Follow", links: ["Merch", "Official Instagram", "Release Terms"] },
];

// Field flags: required defaults to false unless set true. full:true spans the row.
// Types: text, tel, number, url, textarea, select, file, checkboxes.
export const formSections = [
  {
    title: "The Essentials",
    intro:
      "Enter links as full web addresses, including https://. Required fields are marked with an asterisk.",
    fields: [
      { name: "artistName", label: "Artist Name", type: "text", required: true, helper: "As you'd like it to appear on the show." },
      { name: "fullName", label: "Full Name", type: "text", required: true, helper: "Internal use only." },
      { name: "age", label: "Age", type: "number", helper: "Optional." },
      { name: "hometown", label: "Hometown", type: "text", required: true },
      { name: "basedIn", label: "Currently Based In", type: "text", required: true },
      { name: "genres", label: "Genre(s)", type: "text", required: true },
      { name: "years", label: "Years Making Music", type: "text", required: true },
      { name: "instagram", label: "Instagram Handle", type: "text", required: true, placeholder: "@yourhandle" },
      { name: "tiktok", label: "TikTok Handle", type: "text", placeholder: "@yourhandle", helper: "Optional." },
      { name: "spotify", label: "Spotify Link", type: "url", required: true },
      { name: "apple", label: "Apple Music Link", type: "url", required: true },
      { name: "youtube", label: "YouTube Channel", type: "url", required: true },
      { name: "website", label: "Website", type: "url", helper: "Optional." },
    ],
  },
  {
    title: "Who Are You?",
    intro: "Give viewers a quick, honest sense of the artist behind the music.",
    fields: [
      { name: "whoAreYou", label: "In 1\u20132 sentences, tell us who you are as an artist.", type: "textarea", required: true, full: true, maxLength: 250 },
      { name: "realized", label: "When did you realize you wanted to make music?", type: "textarea", required: true, full: true },
      { name: "inspiredStart", label: "What inspired you to start creating music?", type: "textarea", required: true, full: true },
      { name: "changedCareer", label: "What's one moment that changed your music career?", type: "textarea", required: true, full: true },
    ],
  },
  {
    title: "The Story Behind the Hustle",
    intro: "The grind behind the music. Short, specific answers make the best on-screen moments.",
    fields: [
      { name: "hustleMeaning", label: "What does \u201cthe hustle\u201d mean to you?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
      { name: "outsideMusic", label: "What do you do outside of music to support your music career?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
      { name: "sacrifice", label: "What's the biggest sacrifice you've made to pursue music?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
      { name: "crazyThing", label: "What's one thing you've done for your music career that most people would think is crazy?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
      { name: "biggestObstacle", label: "What's been the biggest obstacle you've had to overcome as an independent artist?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
      { name: "hustlingFor", label: "Who are you hustling for?", type: "text", required: true, full: true },
      { name: "keepsGoing", label: "What keeps you going when you feel like giving up?", type: "textarea", required: true, full: true, maxLength: 200, helper: "150\u2013200 characters." },
    ],
  },
  {
    title: "Your Music",
    intro: "Help viewers picture your sound before they even hit play.",
    fields: [
      { name: "threeWords", label: "Describe your sound in three words.", type: "text", required: true, full: true, helper: "Three words only." },
      { name: "influencedSound", label: "Which artists have influenced your sound the most?", type: "textarea", required: true, full: true },
      { name: "takeaway", label: "What message do you hope people take away from your music?", type: "textarea", required: true, full: true, maxLength: 150, helper: "Max 150 characters." },
      { name: "upcomingShows", label: "Do you have any upcoming performances you'd like us to know about?", type: "textarea", full: true, helper: "Optional." },
      { name: "supportBest", label: "What's the best way for fans to support your music?", type: "textarea", required: true, full: true, helper: "Streaming, live shows, merch, Patreon, YouTube, social media, etc." },
    ],
  },
  {
    title: "Behind the Song",
    intro: "The story behind the demo you submitted for First Season.",
    fields: [
      { name: "songStory", label: "Tell us the story behind the song you submitted.", type: "textarea", required: true, full: true, maxLength: 300, helper: "250\u2013300 characters." },
      { name: "writeTime", label: "How long did it take you to write?", type: "text", required: true },
      { name: "whereWrote", label: "Where were you when you wrote it?", type: "text", required: true },
      { name: "songInspired", label: "What inspired this song?", type: "textarea", required: true, full: true, maxLength: 300, helper: "250\u2013300 characters." },
      { name: "proudLyric", label: "What's one lyric you're most proud of?", type: "text", required: true, full: true },
      { name: "musicVideo", label: "Upload the music video to the song you submitted.", type: "file", full: true, helper: "If applicable. Optional." },
    ],
  },
  {
    title: "Your Career",
    intro: "Tell us what you're looking for and what you can bring to the community.",
    fields: [
      {
        name: "opportunities",
        label: "What opportunities are you currently looking for?",
        type: "checkboxes",
        required: true,
        full: true,
        helper: "Select all that apply.",
        options: [
          "Record Deal", "Management", "Producer", "Songwriter", "Collaborators",
          "Publishing", "Distribution", "Sync Licensing", "Booking Agent",
          "Live Performance Opportunities", "Brand Partnerships", "Mentorship",
          "Marketing / PR", "Mixing & Mastering", "Other",
        ],
      },
      {
        name: "canOffer",
        label: "What can you offer the HSS Feed artist community?",
        type: "checkboxes",
        required: true,
        full: true,
        helper: "Select all that apply.",
        options: [
          "Songwriting", "Production", "Beat Making", "Mixing & Mastering",
          "Audio Engineering", "Vocal Coaching", "Live Instrumentation", "DJ Services",
          "Photography", "Videography", "Graphic Design", "Animation / Motion Graphics",
          "Social Media", "Marketing / Branding", "Event Planning", "Choreography",
          "Creative Direction", "Networking", "Other",
        ],
      },
    ],
  },
  {
    title: "Your Journey",
    intro: "Milestones so far. Great material for on-screen artist introductions.",
    fields: [
      { name: "accomplishment", label: "What's your biggest accomplishment so far?", type: "textarea", required: true, full: true, maxLength: 150, helper: "Max 150 characters." },
      { name: "awards", label: "Have you received any awards, recognitions, or notable achievements?", type: "textarea", required: true, full: true, maxLength: 150, helper: "Max 150 characters." },
      { name: "biggestArtist", label: "What's the biggest artist you've worked with?", type: "text", required: true },
      { name: "largestAudience", label: "What's the largest audience you've ever performed for?", type: "text", required: true },
    ],
  },
  {
    title: "Looking Ahead",
    intro: "Where you want the music to take you next.",
    fields: [
      { name: "dreamCollab", label: "Who is your dream collaborator?", type: "text", required: true, maxLength: 75 },
      { name: "dreamVenue", label: "What's your dream venue, festival, or stage to perform on?", type: "text", required: true, maxLength: 100 },
    ],
  },
  {
    title: "Production Assets",
    intro: "Upload high-resolution assets our team can use in the episode and its promotion.",
    fields: [
      { name: "artistPhoto", label: "Upload a high-resolution artist photo.", type: "file", required: true, full: true },
      { name: "performancePhoto", label: "Upload a performance photo.", type: "file", full: true, helper: "Optional." },
      { name: "bio", label: "Artist Bio", type: "textarea", required: true, full: true, helper: "50\u2013100 words." },
    ],
  },
  {
    title: "Final Questions",
    intro: "Last chance to leave a lasting impression.",
    fields: [
      { name: "oneThing", label: "If we could only tell viewers ONE thing about you, what would you want them to know?", type: "textarea", required: true, full: true, maxLength: 100, helper: "Max 100 characters." },
      { name: "grammy", label: "If you won a Grammy tomorrow, who would be the first person you'd thank\u2014and why?", type: "textarea", required: true, full: true, maxLength: 200, helper: "Max 200 characters." },
    ],
  },
];
